import { Controller } from "@hotwired/stimulus"

// Generic copy-to-clipboard button. Pass the text via data-copy-text-source-value.
// Briefly swaps the button's text to "Copied!" on success.
export default class extends Controller {
  static values = { source: String, doneLabel: { type: String, default: "Copied!" }, ms: { type: Number, default: 1500 } }

  async copy(event) {
    event.preventDefault()
    const text = this.sourceValue || ""
    if (!text) return

    try {
      await navigator.clipboard.writeText(text)
    } catch {
      // Fallback for older browsers
      const ta = document.createElement("textarea")
      ta.value = text
      ta.style.position = "fixed"
      ta.style.opacity = "0"
      document.body.appendChild(ta)
      ta.select()
      try { document.execCommand("copy") } catch (_) {}
      document.body.removeChild(ta)
    }

    const btn = this.element
    if (this._timeout) clearTimeout(this._timeout)
    if (!this._original) this._original = btn.textContent
    btn.textContent = this.doneLabelValue
    this._timeout = setTimeout(() => {
      btn.textContent = this._original
      this._original = null
    }, this.msValue)
  }
}
